export const defaultDateFieldOptions = {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
};

export const allDayTime = {
    from: '00:00',
    to: '23:59',
};
